// migrated from next/image → plain <img>. Audit responsive/optimization later.
// next/link → react-router-dom Link (2026-08-26); this component is only
// consumed by Vite apps (tenant-app + super-admin), so a hard dependency
// on react-router is safe. If a future Next.js consumer needs Logo, wrap
// it in a router-agnostic version at the call site.
import { Link } from "react-router-dom"

interface LogoProps {
  collapsed?: boolean
}

export function Logo({ collapsed = false }: LogoProps) {
  return (
    <Link to="/" className="flex items-center">
      {collapsed ? (
        <div className="w-8 h-8 relative">
          <img src="/Purple Logo icon png.png" alt="Edemics" width={32} height={32} className="object-contain" />
        </div>
      ) : (
        <div className="h-8 w-auto relative">
          <img src="/edemics-logo.png" alt="Edemics" width={120} height={32} className="object-contain" />
        </div>
      )}
    </Link>
  )
}
